module.exports = __webpack_public_path__ + "static/media/kh.5a13865d.svg";